import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {
	getRefundEligibleProceduresPage,
	PROCEDURES_FULL_LIST_LIMIT,
} from 'presentation/pages/private/refund/pages/RequestPreview/services/getRefundEligibleProcedures';
import type {UseSearchProcedurePreviewQueryProps} from './types';

export const useSearchProcedurePreviewQuery = ({
	beneficiaryUserCode,
}: UseSearchProcedurePreviewQueryProps) =>
	useQuery({
		queryKey: [QUERY_KEYS.REFUND_PREVIEW_PROCEDURE_SEARCH, beneficiaryUserCode],
		queryFn: ({signal}) =>
			getRefundEligibleProceduresPage({
				page: 1,
				limit: PROCEDURES_FULL_LIST_LIMIT,
				signal,
			}),
		enabled: !!beneficiaryUserCode,
		staleTime: Number.POSITIVE_INFINITY,
		refetchOnWindowFocus: false,
	});
